import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginComponent } from './auth/login/login.component';
import { DistribuidorFormComponent } from './pages/distribuidor-form/distribuidor-form.component';
import { FacturaFormComponent } from './pages/factura-form/factura-form.component';
import { FacturaLstEmpresaComponent } from './pages/factura-lst-empresa/factura-lst-empresa.component';
import { ProductoFormComponent } from './pages/producto-form/producto-form.component';
import { RegisterComponent } from './auth/register/register.component';
import { SigninComponent } from './auth/signin/signin.component';
import { FacturaLstComponent } from './pages/factura-lst/factura-lst.component';
import { TrazabilidadFormComponent } from './pages/trazabilidad-form/trazabilidad-form.component';
import { ProductosFacuradosLstComponent } from './pages/productos-facurados-lst/productos-facurados-lst.component';
import { AuthService } from 'src/app/services/auth.service';
import { AdminFormComponent } from './auth/admin-form/admin-form.component';
import { DistribuidorLstComponent } from './pages/distribuidor-lst/distribuidor-lst.component';


const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
  Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const router = inject(Router);
  const auth = inject(AuthService);
  const roles = route.data['roles'] as string[]
  //console.log("Route: ", roles, state.url);
  if (auth.sessionActive()) {
    return true;
  } else {
    router.navigate(['']);
    return false;
  }

};


const routes: Routes = [
  { path: 'login', component: LoginComponent },
  // { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'signin', component: SigninComponent },
  { path: 'registrar', component: RegisterComponent },
  { path: 'nuevo/administrador', component: AdminFormComponent },
  { path: 'distribuidor', component: DistribuidorFormComponent, canActivate: [authGuard] },
  { path: 'factura', component: FacturaFormComponent, canActivate: [authGuard] },
  { path: 'facturas', component: FacturaLstComponent, canActivate: [authGuard] },
  { path: 'facturas/empresa/:id', component: FacturaLstEmpresaComponent, canActivate: [authGuard] },
  { path: 'distribuidores', component: DistribuidorLstComponent, canActivate: [authGuard] },
  { path: 'producto', component: ProductoFormComponent, canActivate: [authGuard] },
  { path: 'trazabilidad/:id', component: TrazabilidadFormComponent, canActivate: [authGuard], data: { roles: [1, 2] } },
  { path: 'productos-facturados', component: ProductosFacuradosLstComponent, canActivate: [authGuard] }
  // …
  // …
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
